// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import GridPickerTemplate from '@front/templates/GridPickerTemplate.html';
import { Control } from './Control';
export class GridPicker extends Control {
    constructor() {
        super();
    }
    getType() {
        return 'GridPicker';
    }
    oninit() {
        super.oninit();
        this.gridItemMouseEnter = this.gridItemMouseEnter.bind(this);
        this.gridItemMouseClick = this.gridItemMouseClick.bind(this);
        this.restoreDefaultSelection = this.restoreDefaultSelection.bind(this);
    }
    gridItemMouseEnter(row, column) {
        void this.set({
            rowsSelected: row,
            columnsSelected: column
        });
    }
    gridItemMouseClick() {
        const rowsSelected = this.get('rowsSelected');
        const columnsSelected = this.get('columnsSelected');
        this.fire(GridPicker.Events.Selected, rowsSelected, columnsSelected);
    }
    restoreDefaultSelection() {
        void this.set({
            rowsSelected: this.get('defaultRowsSelected'),
            columnsSelected: this.get('defaultColumnsSelected')
        });
    }
}
GridPicker.Events = {
    Selected: 'selected'
};
Control.extendWith(GridPicker, {
    template: GridPickerTemplate,
    data: function () {
        return {
            grid: null,
            rows: [1, 2, 3, 4, 5],
            columns: [1, 2, 3, 4, 5, 6],
            defaultRowsSelected: 1,
            defaultColumnsSelected: 1,
            rowsSelected: 1,
            columnsSelected: 1
        };
    }
});
